import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { AddCustomerFromBranchComponent }   from './customer.add-from-branch.component';
import { CustomerBranchHistoryComponent } from './customer.branch-history.component';
import { CustomerActivityLogsComponent }  from './customer.activity-logs.component';
import { CustomerComponent }              from './customer.component';
import { CustomersListComponent }         from './customers.list.component';
import { CustomerTypePipe }               from './customer.type.pipe';
import { SharedModule }                   from '../shared/shared.module';
import { TableModule }                    from '../table/table.module';

@NgModule({
  declarations: [
    AddCustomerFromBranchComponent,
    CustomerBranchHistoryComponent,
    CustomerActivityLogsComponent,
    CustomerComponent,
    CustomersListComponent,
    CustomerTypePipe
  ],
  entryComponents: [
    AddCustomerFromBranchComponent,
    CustomerBranchHistoryComponent,
    CustomerActivityLogsComponent,
    CustomerComponent,
    CustomersListComponent
  ],
  exports: [
    CustomerTypePipe,
    CustomersListComponent,
  ],
  imports: [
    SharedModule,
    TableModule
  ],
  providers: [
    CustomerTypePipe,
    {
      provide : 'customerType',
      useClass: CustomerTypePipe
    }
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class CustomersModule {}
